import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntCalendarComponent} from "./int-calendar.component";
import {DateControllerModule, IntDaySelectorModule, IntMonthSelectorModule} from "../../entities";
import {IntYearSelectorModule} from "../../entities/components/year-selector/int-year-selector.module";

@NgModule({
  imports: [
    CommonModule,
    IntDaySelectorModule,
    IntMonthSelectorModule,
    DateControllerModule,
    IntYearSelectorModule
  ],
  declarations: [
    IntCalendarComponent
  ],
  exports: [
    IntCalendarComponent
  ]
})
export class IntCalendarModule {}

